var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHumidity = function SvgHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "humidity_svg2__a",
    x1: 50.55,
    x2: 151.55,
    y1: 184.43,
    y2: 56.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#humidity_svg2__a",
    id: "humidity_svg2__b",
    x1: 47.48,
    x2: 148.48,
    y1: 182.01,
    y2: 54.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#humidity_svg2__a",
    id: "humidity_svg2__c",
    x1: 72.84,
    x2: 173.84,
    y1: 202.02,
    y2: 74.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#humidity_svg2__a",
    id: "humidity_svg2__d",
    x1: 21.64,
    x2: 122.64,
    y1: 161.62,
    y2: 33.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#humidity_svg2__a",
    id: "humidity_svg2__e",
    x1: 35.83,
    x2: 136.83,
    y1: 172.82,
    y2: 44.82
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 200c-42.87 0-77.75-34.95-77.75-77.91 0-17.85 6.16-35.24 17.37-49.07.09-.14.18-.27.28-.4L94.55 2.77a7.2 7.2 0 0 1 5.7-2.77h.02c2.25 0 4.32 1.03 5.7 2.8l23.16 29.89c1.92 2.47 1.46 6.03-1 7.94a5.664 5.664 0 0 1-7.94-1.01l-19.95-25.74L49.21 79.1c-.13.21-.28.42-.44.61-9.8 11.89-15.2 26.94-15.2 42.38 0 36.72 29.8 66.58 66.43 66.58s66.43-29.87 66.43-66.58c0-15.28-5.3-30.21-14.92-42.03l-12.53-16.17c-1.91-2.48-1.46-6.03 1.01-7.94a5.646 5.646 0 0 1 7.94 1.01l12.45 16.07c11.17 13.74 17.37 31.2 17.37 49.07 0 42.96-34.88 77.91-77.75 77.91",
    style: {
      fill: "url(#humidity_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.44 154.75c-.95 0-1.93-.24-2.82-.75a5.66 5.66 0 0 1-2.08-7.73l37.58-65.34c1.56-2.71 5.02-3.64 7.73-2.08s3.65 5.02 2.09 7.73l-37.58 65.33a5.66 5.66 0 0 1-4.91 2.84",
    style: {
      fill: "url(#humidity_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.22 154.75c-9.14 0-16.58-7.44-16.58-16.58s7.44-16.58 16.58-16.58 16.58 7.44 16.58 16.58-7.44 16.58-16.58 16.58m0-21.85c-2.9 0-5.26 2.36-5.26 5.26s2.36 5.26 5.26 5.26 5.26-2.36 5.26-5.26-2.36-5.26-5.26-5.26",
    style: {
      fill: "url(#humidity_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.78 108.32c-9.14 0-16.58-7.44-16.58-16.58s7.44-16.58 16.58-16.58 16.58 7.44 16.58 16.58-7.44 16.58-16.58 16.58m0-21.84c-2.9 0-5.26 2.36-5.26 5.26S73.88 97 76.78 97s5.26-2.36 5.26-5.26-2.36-5.26-5.26-5.26",
    style: {
      fill: "url(#humidity_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.15 53.88c-1.51 0-2.94-.57-4-1.66a5.65 5.65 0 0 1-1.66-4c0-.38.04-.72.11-1.09.08-.38.19-.72.3-1.06.15-.34.34-.68.53-.98.23-.3.45-.6.72-.87.26-.26.53-.49.87-.71.3-.19.6-.38.98-.49.34-.15.68-.26 1.06-.34a5.66 5.66 0 0 1 5.09 1.55c1.06 1.06 1.66 2.53 1.66 4s-.6 2.94-1.66 4c-1.06 1.09-2.49 1.66-4 1.66",
    style: {
      fill: "url(#humidity_svg2__e)"
    }
  }));
};
export default SvgHumidity;